import api from "../utils/api";

export const getConfig = () => {
    return api.get("/config", {});
};
